// extracted by mini-css-extract-plugin
export default {"showScrollToTopButton":"q_bv","scrollToTop":"q_bw"};